<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.qualityItem.list") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityItem">
              <span>{{$t('tlt.qualityItem.list')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('qualityItem')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityItemCode")}}</label>
                 <input
                  class="form-control"
                  type="text"
                  v-model="itemCodeFilter"
                />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityItemName")}}</label>
                  <input
                  class="form-control"
                  type="text"
                  v-model="itemNameFilter"
                />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityItemCraftType")}}</label>
                  <select class="form-control" v-model="craftTypeFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="Q">{{$t("lbl.qualityItem.pelletizing")}}</option>
                    <option value="Y">{{$t("lbl.qualityItem.smelt")}}</option>  
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityItemCheckType")}}</label>
                  <select class="form-control" v-model="checkTypeFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="material">{{$t("lbl.qualityItem.material")}}</option>
                    <option value="process">{{$t("lbl.qualityItem.process")}}</option>
                    <option value="production">{{$t("lbl.qualityItem.production")}}</option>
                  </select>
                </div>

                  <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                     <button class="btn btn-outline-secondary mr-1" type="button"
                                         v-on:click="MMFClearFilter('qualityItem')">
                          <i class="fa fa-fw fa-lg fa-eraser"></i>
                          <span class="text">{{ $t("btn.basic.clear") }}</span>
                      </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('qualityItem')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

       <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          
           <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component">
              </div>
              <mmf-table entity="qualityItem" inline-actions-disabled :singleChoice='true'>
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    :disabled = "slotProps.checkedLength !=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="View(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityItem.details") }}</span>
                  </button>
                  
                </div>
                </mmf-table>
            </div>
          </div>
        </div>
      </div>

    </section>
   
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItem";
import { gridFields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItem";
import MmfTable from "@/components/MmfTable";
import dimsearch from "@/components/MMFDimSearch";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityItem/getField",
  mutationType: "qualityItem/updateField"
});

export default {
  name: "qualityItemList",
  data() {
    return {
      items:[]
    };
  },
  components: { MmfTable ,dimsearch},
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
   
    ...mapFields(filterFields),
  
    ...mapState({
      rows: state => state.qualityItem.rows,
      tableColumns: gridFields,
      entity: state => state.qualityItem.entity,  
     
    })
  },
  methods: {
    ...mapActions("qualityItem",["QualityItemNew","View"]),
    ...mapActions("base", ["MMFLoadRows","MMFClearFilter","MMFNew" ]),
    
   
  },
  mounted() {},
    created() {
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.qualityItem.baseModuleUrl +
            "/qualityItem/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        this.items = data;
      });
    
  }
};
</script>
